export default __webpack_public_path__ + "static/media/championspackage_2025.4bc4d5d6.jpg";